import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { ArrowUpCircle, ArrowDownCircle, Wallet, Trash2 } from 'lucide-react';
import { categoriaLabels } from './constants';

export default function CaixaTab({ 
  movimentacoes, 
  onNovaReceita, 
  onNovaDespesa, 
  onDelete 
}) {
  return (
    <div className="space-y-4">
      <div className="flex justify-between items-center">
        <h3 className="text-lg font-semibold">Movimentações Financeiras</h3>
        <div className="flex gap-2">
          <Button 
            variant="outline" 
            className="text-green-600 border-green-300 hover:bg-green-50"
            onClick={onNovaReceita}
            data-testid="btn-nova-receita"
          >
            <ArrowUpCircle className="w-4 h-4 mr-2" />
            Nova Receita
          </Button>
          <Button 
            variant="outline"
            className="text-red-600 border-red-300 hover:bg-red-50"
            onClick={onNovaDespesa}
            data-testid="btn-nova-despesa"
          >
            <ArrowDownCircle className="w-4 h-4 mr-2" />
            Nova Despesa
          </Button>
        </div>
      </div>
      
      <div className="grid gap-3">
        {movimentacoes.length === 0 ? (
          <Card>
            <CardContent className="py-8 text-center text-slate-500">
              <Wallet className="w-12 h-12 mx-auto mb-3 text-slate-300" />
              <p>Nenhuma movimentação encontrada</p>
              <p className="text-sm mt-1">Clique em "Nova Receita" ou "Nova Despesa" para começar</p>
            </CardContent>
          </Card>
        ) : (
          movimentacoes.map(mov => (
            <Card 
              key={mov.id} 
              data-testid={`movimentacao-${mov.id}`} 
              className={`border-l-4 ${mov.tipo === 'receita' ? 'border-l-green-500' : 'border-l-red-500'}`}
            >
              <CardContent className="py-4">
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-4">
                    <div className={`p-2 rounded-full ${mov.tipo === 'receita' ? 'bg-green-100' : 'bg-red-100'}`}>
                      {mov.tipo === 'receita' 
                        ? <ArrowUpCircle className="w-5 h-5 text-green-600" />
                        : <ArrowDownCircle className="w-5 h-5 text-red-600" />
                      }
                    </div>
                    <div>
                      <p className="font-medium">{mov.descricao}</p>
                      <div className="flex items-center gap-2 text-sm text-slate-500">
                        <Badge variant="outline" className="text-xs">
                          {categoriaLabels[mov.categoria] || mov.categoria}
                        </Badge>
                        <span>•</span>
                        <span>{new Date(mov.data_movimentacao).toLocaleDateString('pt-BR')}</span>
                        {mov.cliente_nome && (
                          <>
                            <span>•</span>
                            <span>{mov.cliente_nome}</span>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="flex items-center gap-4">
                    <p className={`text-lg font-bold ${mov.tipo === 'receita' ? 'text-green-600' : 'text-red-600'}`}>
                      {mov.tipo === 'receita' ? '+' : '-'} R$ {mov.valor?.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
                    </p>
                    <Button size="icon" variant="ghost" onClick={() => onDelete(mov.id)}>
                      <Trash2 className="w-4 h-4 text-red-500" />
                    </Button>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))
        )}
      </div>
    </div>
  );
}
